'use strict';

angular.module('mobile-apps').factory('AvailableLanguages', ['$resource', '$cacheFactory',
    function ($resource, $cacheFactory) {
        var availableLanguagesCache = $cacheFactory('AvailableLanguagesCache');
        return $resource(
            'v1/available-languages',
            {

            },
            {
                get:
                {
                    method:'GET',
                    cache: availableLanguagesCache
                }
            }
        );
    }
]);
